"use client";

import React, {useCallback, useMemo, useReducer} from "react";


const initialState = {
    displaySidebar: false,
    categories: [],
    liveChat: false,
    liveChatOpen: false,
    consentLayout: false,
    menu: [],
    overflow: false,
};

const LayoutContext = React.createContext(null);

LayoutContext.displayName = 'LayoutContext';

function uiReducer(state, action) {
    //console.log(action);
    switch (action.type) {
        case 'OPEN_SIDEBAR': {
            return {
                ...state,
                displaySidebar: true,
            }
        }
        case 'SET_PAGE_OVERFLOW': {
            return {
                ...state,
                overflow: action.payload,
            }
        }
        case 'CLOSE_SIDEBAR': {
            return {
                ...state,
                displaySidebar: false,
            }
        }

        case 'LOAD_MENU': {
            return {
                ...state,
                menu: action.payload,
            }
        }
        case 'LOAD_CATEGORIES': {
            return {
                ...state,
                categories: action.payload,

            }
        }
/*        case 'LOAD_LIVE_CHAT': {
            return {
                ...state,
                liveChat: action.payload,
            }
        }*/
        case 'TOGGLE_LIVE_CHAT': {
            return {
                ...state,
                liveChatOpen: !state.liveChatOpen,
            }
        }
        case 'SET_CONSENT_LAYOUT': {
            return {
                ...state,
                consentLayout: action.payload,
            }
        }
    }
}

export const LayoutProvider = (props) => {
    const [state, dispatch] = useReducer(uiReducer, initialState);


    const setPageOverflow = useCallback(
        (value) => dispatch({type: 'SET_PAGE_OVERFLOW', payload: value}),
        [dispatch]
    );

    const openSidebar = useCallback(
        () => dispatch({type: 'OPEN_SIDEBAR'}),
        [dispatch]
    );
    const closeSidebar = useCallback(
        () => dispatch({type: 'CLOSE_SIDEBAR'}),
        [dispatch]
    );

    const loadLiveChat = useCallback(
        (config) => dispatch({type: 'LOAD_LIVE_CHAT', payload: config}),
        [dispatch]
    );

    const toggleLiveChat = useCallback(
        () => dispatch({type: 'TOGGLE_LIVE_CHAT'}),
        [dispatch]
    );

    const setConsentLayout = useCallback(
        (value) => dispatch({type: 'SET_CONSENT_LAYOUT', payload: value}),
        [dispatch]
    );

    const value = useMemo(
        () => ({
            ...state,
            openSidebar,
            closeSidebar,
            loadLiveChat,
            toggleLiveChat,
            setConsentLayout,
            setPageOverflow
        }),
        [state]
    ) // eslint-disable-line react-hooks/exhaustive-deps

    return <LayoutContext.Provider value={value} {...props} />

}

export const useLayoutContext = () => {
    const context = React.useContext(LayoutContext);
    if (context === undefined) {
        throw new Error(`useLayoutContext must be used within a LayoutProvider`)
    }
    return context
}

export const UIContext = (props) => {

    return <LayoutProvider {...props}>{props.children}</LayoutProvider>;
}